import Vue from 'vue'
import Vuex from 'vuex'
import appLang from './modules/appLang'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    appLang
  }

})

export default store
